import React from 'react';

// Each pattern component accepts a 'colors' object mapping zone IDs to hex codes
// and an optional className for sizing/rotation.

export const PatternStar = ({ colors, className = "" }) => (
  <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Background */}
    <rect x="0" y="0" width="100" height="100" fill={colors.bg || '#FFFFFF'} />
    
    {/* Corner Triangles */}
    <path d="M0 0 L30 0 L0 30 Z" fill={colors.corners || '#E6D0B3'} />
    <path d="M100 0 L70 0 L100 30 Z" fill={colors.corners || '#E6D0B3'} />
    <path d="M100 100 L70 100 L100 70 Z" fill={colors.corners || '#E6D0B3'} />
    <path d="M0 100 L30 100 L0 70 Z" fill={colors.corners || '#E6D0B3'} />

    {/* Main Star Shape */}
    <path d="M50 10 L60 40 L90 50 L60 60 L50 90 L40 60 L10 50 L40 40 Z" fill={colors.star || '#3B7CA8'} />
    
    {/* Inner Detail */}
    <circle cx="50" cy="50" r="10" fill={colors.center || '#1F2F45'} />
  </svg>
);

export const PatternFloral = ({ colors, className = "" }) => (
  <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Background */}
    <rect x="0" y="0" width="100" height="100" fill={colors.bg || '#FDF6E3'} />
    
    {/* Petals */}
    <path d="M50 50 Q50 0 0 0 L0 50 Z" fill={colors.petal1 || '#D8A49B'} />
    <path d="M50 50 Q50 0 100 0 L100 50 Z" fill={colors.petal2 || '#D8A49B'} />
    <path d="M50 50 Q50 100 100 100 L100 50 Z" fill={colors.petal3 || '#D8A49B'} />
    <path d="M50 50 Q50 100 0 100 L0 50 Z" fill={colors.petal4 || '#D8A49B'} />
    
    {/* Center Diamond */}
    <path d="M50 30 L70 50 L50 70 L30 50 Z" fill={colors.center || '#9A4535'} />
  </svg>
);

export const PatternGeo = ({ colors, className = "" }) => (
  <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect x="0" y="0" width="100" height="100" fill={colors.bg || '#FFFFFF'} />
    
    {/* Cubes Effect */}
    <path d="M0 0 L50 25 L0 50 Z" fill={colors.left || '#708090'} />
    <path d="M0 0 L50 25 L50 -25 Z" fill={colors.top || '#9E9DAD'} /> 
    {/* Adjusted for tiling logic, simple diamonds here */}
    <path d="M50 25 L100 0 L100 50 L50 75 Z" fill={colors.right || '#36454F'} />
    <path d="M0 50 L50 75 L50 100 L0 100 Z" fill={colors.bottom || '#708090'} />
    <path d="M50 75 L100 50 L100 100 L50 100 Z" fill={colors.bottomRight || '#1A1A1A'} />

    {/* Central Line */}
    <line x1="0" y1="100" x2="100" y2="0" stroke={colors.lines || '#FFFFFF'} strokeWidth="2" />
  </svg>
);

export const PatternCross = ({ colors, className = "" }) => (
  <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect x="0" y="0" width="100" height="100" fill={colors.bg || '#FFFFFF'} />
    <rect x="35" y="0" width="30" height="100" fill={colors.cross || '#2E5D4B'} />
    <rect x="0" y="35" width="100" height="30" fill={colors.cross || '#2E5D4B'} />
    <rect x="40" y="40" width="20" height="20" fill={colors.center || '#1A3C34'} />
    <circle cx="15" cy="15" r="8" fill={colors.dots || '#9CAF88'} />
    <circle cx="85" cy="15" r="8" fill={colors.dots || '#9CAF88'} />
    <circle cx="15" cy="85" r="8" fill={colors.dots || '#9CAF88'} />
    <circle cx="85" cy="85" r="8" fill={colors.dots || '#9CAF88'} />
  </svg>
);

export const patterns = [
  {
    id: 'star',
    name: 'Andalusia Star',
    component: PatternStar,
    zones: [
      { id: 'bg', label: 'Background' },
      { id: 'corners', label: 'Corners' },
      { id: 'star', label: 'Main Star' },
      { id: 'center', label: 'Center Dot' },
    ],
    defaultColors: { bg: '#FFFFFF', corners: '#E6D0B3', star: '#3B7CA8', center: '#1F2F45' }
  },
  {
    id: 'floral',
    name: 'Valencia Floral',
    component: PatternFloral,
    zones: [
      { id: 'bg', label: 'Background' },
      { id: 'petal1', label: 'Top Left Petal' },
      { id: 'petal2', label: 'Top Right Petal' },
      { id: 'petal3', label: 'Bottom Right Petal' },
      { id: 'petal4', label: 'Bottom Left Petal' },
      { id: 'center', label: 'Diamond Center' },
    ],
    defaultColors: { bg: '#FDF6E3', petal1: '#D8A49B', petal2: '#D8A49B', petal3: '#D8A49B', petal4: '#D8A49B', center: '#9A4535' }
  },
  {
    id: 'geo',
    name: 'Modern Geometric',
    component: PatternGeo,
    zones: [
      { id: 'bg', label: 'Background' },
      { id: 'left', label: 'Left Facet' },
      { id: 'right', label: 'Right Facet' },
      { id: 'bottom', label: 'Bottom Left' },
      { id: 'bottomRight', label: 'Bottom Right' },
      { id: 'lines', label: 'Accent Lines' },
    ],
    defaultColors: { bg: '#FFFFFF', left: '#708090', right: '#36454F', bottom: '#708090', bottomRight: '#1A1A1A', lines: '#FFFFFF' }
  },
  {
    id: 'cross',
    name: 'Lisbon Cross',
    component: PatternCross,
    zones: [
      { id: 'bg', label: 'Background' },
      { id: 'cross', label: 'Cross Bars' },
      { id: 'center', label: 'Center Square' },
      { id: 'dots', label: 'Corner Dots' },
    ],
    defaultColors: { bg: '#FFFFFF', cross: '#2E5D4B', center: '#1A3C34', dots: '#9CAF88' }
  }
];